import { makeAutoObservable, runInAction } from 'mobx';
import {
  DetailedScheduleData,
} from 'screens/DetailedScheduleScreen/detailedScheduleTypes';
import { detailedScheduleService } from 'services/DetailedScheduleServices/detailedScheduleService';
import { toast } from 'react-toastify';
export class DetailedScheduleStore {
  isLoading: boolean = false;
  detailedSchedule: DetailedScheduleData[] | [] = [];
  environment = import.meta.env.VITE_ENVIRONMENT;

  constructor() {
    makeAutoObservable(this);
  }

  fetchDetailedSchedule = async (date: string) => {
    this.isLoading = true;
    try {
      const response = await detailedScheduleService.getDetailedSchedule(date);
      runInAction(() => {
        this.detailedSchedule = response.detailed_schedule;
      });
    } catch (error) {
      if (this.environment === 'development') {
        console.error('Error fetching detailed schedule:', error);
      }
      toast.error('Error fetching detailed schedule data!');
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };
}
